import React from 'react'
import { Theme, useMediaQuery } from '@mui/material'
import { DesktopMenu } from './desktop-menu'
import { MobileMenu } from './mobile-menu'

export const MenuRoot: React.FC = (): JSX.Element => {
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down(1150))

  return md ? <MobileMenu /> : <DesktopMenu />
}
